import styled from 'styled-components'

export const StyledTitleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  white-space: nowrap;
  overflow: hidden;
`
